import React from "react";
import { PageContent } from "../../../page-content/page-content";
import { useQuery } from "@tanstack/react-query";
import { BtmReturnsList } from "../btm-returns-list/btm-returns-list";
import { GetFinalizedReturnRequestsHandler } from "../cqrs/get-finalized-return-requests/get-finalized-return-requests-handler";
import { GetFinalizedReturnRequestQuery } from "../cqrs/get-finalized-return-requests/get-finalized-return-request-query";
import { t } from "i18next";
import { context } from "../../../../context/context";
import { WarehouseSelector } from "../../pallet/warehouse-selector/warehouse-selector";
import { useNavigate } from "react-router-dom";
import { BtmReturnRequestListItem } from "../model/btm-return-request-list-item";

export const BTMFinalizedReturns = ({ warehouseCode }: { warehouseCode: string | undefined }) => {
    return <PageContent title={t("components.blueBrandReturns.page.finalizedReturns.title")}
                        description={t("components.blueBrandReturns.page.finalizedReturns.description")}
                        className={"btm-returns-page"}>
        {(context.currentUser.isSuperAdministrator || context.currentUser.isSrmAgent) && <WarehouseSelector section={"btm-returns"} selectedWarehouse={warehouseCode} />}
        {warehouseCode && <BTMFinalizedReturnsContent warehouseCode={warehouseCode} />}
    </PageContent>;
};

const BTMFinalizedReturnsContent = ({ warehouseCode }: { warehouseCode: string }) => {
    const { data, isLoading } = useQuery({
        queryKey: [`btm-returns-finalized-${warehouseCode}`],
        queryFn: async () =>
            await GetFinalizedReturnRequestsHandler(new GetFinalizedReturnRequestQuery(warehouseCode)),
    });
    const navigate = useNavigate();

    const handleRequestOpen = (requestId: BtmReturnRequestListItem) => {
        navigate(`/btm-returns/details/${requestId.returnRequestId}`);
    };

    return <BtmReturnsList withStatus onRequestOpen={handleRequestOpen} data={data} isLoading={isLoading} />;
};
